const LangSignUp = {
	"signUp.form._createAccount": ["MEMBER REGISTRATION", "TẠO TÀI KHOẢN"],
	"signUp.form._passwordRules": [
		"Password must be:<br />At least 8 characters <br />Contain alpha-numeric characters",
		"Mật khẩu phải:<br />Dài 8-15 ký tự, bao gồm ít nhất 1 chữ in hoa, 1 chữ in thường, 1 số và 1 ký tự đặc biệt.",
	],
	"signUp.form._subtitle": [
		"Sign up for our lifetime FREE membership to get Rebate every time you dine with us! After successful sign up, simply enter your mobile number upon payment to enjoy Rebate with no minimum spending! Rebate earned is usable as payment at more than 70 outlets island-wide.",
		"Sign up for our lifetime FREE membership to get Rebate every time you dine with us! After successful sign up, simply enter your mobile number upon payment to enjoy Rebate with no minimum spending! Rebate earned is usable as payment at more than 70 outlets island-wide.",
	],
	"signUp.form._consentAgreementRules": [
		"By clicking this button, I agree to the Japan Foods Holding Site&nbsp;",
		"Bằng cách bấm nút bên dưới, tôi đã đọc và đồng ý với Japan Foods Holding&nbsp;",
	],
	"signUp.form.label._consentAgreementCheck": [
		"I have read and agree to the Terms and Conditions of\
		the Japan Foods Holding Gift Card program (Click Here to view T&C’s)",
		"I have read and agree to the Terms and Conditions of\
		the Japan Foods Holding Gift Card program (Click Here to view T&C’s)",
	],
	"signUp.form.name._consentAgreementCheck": [
		"Consent Agreement Check",
		"Consent Agreement Check",
	],
	"signUp.form._termOfUse": ["Terms & Conditions", "Điều kiện điều khoản"],
	"signUp.form.label._consentAgreement_": [
		"By signing up as a member, I agreed to be contacted via telephone, SMS, emails or any other means for member privileges, ongoing promotions, reward redemptions or any membership related matters. Japan Foods Holding Ltd. will keep your information adhering to its Protection and Privacy Policy",
		"By signing up as a member, I agreed to be contacted via telephone, SMS, emails or any other means for member privileges, ongoing promotions, reward redemptions or any membership related matters. Japan Foods Holding Ltd. will keep your information adhering to its Protection and Privacy Policy",
	],
	"signUp.form.label._consentAgreement": [
		"I do not wish to receive news, special offers and more from Japan Foods Holding.",
		"Không đồng ý nhận email khuyến mãi từ chương trình.",
	],
	"signUp.form.name._consentAgreement": ["Consent Agreement", "vi_Consent Agreement"],
	"signUp.form._Whatisthis": ["What is this?", "vi_What is this?"],
	"signUp.form._Scratch": [
		"Scratch off this portion at the back of your card",
		"Vui lòng nhập dãy số dưới lớp cào",
	],
}

export default LangSignUp



// WEBPACK FOOTER //
// ./src/resources/pages/LangSignUp.js